
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class CellManager extends Vue {
  @Prop({ type: String, default: null }) fuel: string | null
  @Prop({ type: String, default: null }) transmission: string | null
  @Prop({ type: String, default: null }) traction: string | null
  }
